import { api } from '..';

export type UpsertCellParams = {
  collaboratorId: string;
  year: number;
  month: string;
  compensationCents?: number;
  healthPlanCents?: number;
};

export type CreateYearParams = {
  collaboratorId: string;
  year: number;
  baseCompensationCents?: number;
  baseHealthPlanCents?: number;
};

export type StartYearParams = {
  previousYear: number;
  newYear: number;
};

export const grid = async (collaboratorId: string, year: number) => {
  return api.get('/estimativa-colaboradores', {
    params: { collaboratorId, year },
  });
};

export const matrix = async (year: number, costCenterId?: string) => {
  return api.get('/estimativa-colaboradores/matriz', {
    params: { year, costCenterId },
  });
};

export const createYear = async (params: CreateYearParams) => {
  return api.post('/estimativa-colaboradores/ano', { ...params });
};

export const upsertCell = async (params: UpsertCellParams) => {
  return api.patch('/estimativa-colaboradores/celula', { ...params });
};

export const startYear = async (params: StartYearParams) => {
  return api.post('/estimativa-colaboradores/iniciar-ano', { ...params });
};

export const applyFromMonth = async (params: UpsertCellParams) => {
  return api.patch('/estimativa-colaboradores/aplicar-do-mes', { ...params });
};
